import React, { useEffect, useState } from "react";
import { db } from "../../firebase";
import { useAuth } from "../../context/AuthContext";
import {
  collection,
  query,
  where,
  getDocs,
  updateDoc,
  doc,
} from "firebase/firestore";
import { format } from "date-fns";
import { Phone } from "lucide-react";
import { MapContainer, TileLayer, Marker, Polyline, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import {getDoc, serverTimestamp, deleteField } from "firebase/firestore";
import { useNavigate } from "react-router-dom";


import { Link } from "react-router-dom";



// Map marker icons
const inIcon = new L.Icon({
  iconUrl:
    "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-green.png",
  iconSize: [25, 41],
  iconAnchor: [12, 41],
});
const outIcon = new L.Icon({
  iconUrl:
    "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-red.png",
  iconSize: [25, 41],
  iconAnchor: [12, 41],
});

function isShiftCompleted(shift) {
  if (!shift.date || !shift.endTime) return false;

  const now = new Date();
  const shiftEndTime = new Date(shift.date);

  // Handle formats like "14:30–16:30" or just "16:30"
  let endStr = shift.endTime;
  if (shift.startTime?.includes("–")) {
    endStr = shift.startTime.split("–")[1];
  } else if (shift.startTime?.includes("-")) {
    endStr = shift.startTime.split("-")[1];
  }

  const [endHour, endMin] = endStr.split(":").map(Number);
  shiftEndTime.setHours(endHour || 0);
  shiftEndTime.setMinutes(endMin || 0);

  return now > shiftEndTime;
}



export default function MyShifts() {
  const { user } = useAuth();
  console.log("AUTH USER:", user);

  const [loading, setLoading] = useState(true);
 
  const navigate = useNavigate();

 
  const [allShifts, setAllShifts] = useState({ upcoming: [], past: [] });

  const [daysAvailable, setDaysAvailable] = useState([]);
  const [saving, setSaving] = useState(false);
  const [staffDocId, setStaffDocId] = useState(null);
  const [showPast, setShowPast] = useState(false);
const [visibleUpcomingCount, setVisibleUpcomingCount] = useState(2);

const [availableShifts, setAvailableShifts] = useState([]);
const [showAvailable, setShowAvailable] = useState(false);






const requestShift = async (shiftId) => {
  try {
    const ref = doc(db, "shifts", shiftId);
    const snap = await getDoc(ref);

    if (!snap.exists()) return;

    const data = snap.data();
    const requests = Array.isArray(data.requests) ? data.requests : [];

    // prevent duplicates
    if (requests.some(r => r.email === user.email)) {
      alert("You already requested this shift.");
      return;
    }

    const newRequests = [
      ...requests,
      {
        uid: user.uid ?? user.email ?? "unknown-user",
        name: user.name ?? "",
        email: user.email ?? "",
        requestedAt: Date.now(),
      }
    ];


console.log("DEBUG — shift ID:", shiftId);
console.log("DEBUG — newRequests array:", newRequests);

newRequests.forEach((req, i) => {
  Object.entries(req).forEach(([k, v]) => {
    if (v === undefined) {
      console.error(`❌ ERROR: undefined value in requests[${i}].${k}`);
    }
  });
});








    await updateDoc(ref, {
  requests: newRequests,
  requestedBy: deleteField(),
  requestedByName: deleteField(),
  requestedAt: deleteField(),
});


    
    setAvailableShifts(prev =>
  prev.map(s =>
    s.id === shiftId ? { ...s, requests: newRequests } : s
  )
);
alert("Shift requested!");
  } catch (err) {
    console.error("REQUEST ERROR:", err);
  }
};



const cancelShiftRequest = async (shiftId) => {
  try {
    console.log("CANCEL — shiftId:", shiftId);

    const ref = doc(db, "shifts", shiftId);
    const snap = await getDoc(ref);

    if (!snap.exists()) {
      console.log("CANCEL — shift not found");
      return;
    }

    const data = snap.data();
    const requests = Array.isArray(data.requests) ? data.requests : [];

    console.log("CANCEL — existing requests:", requests);

    // Remove this user
    const newRequests = requests.filter(r => r.email !== user.email);

    console.log("CANCEL — newRequests:", newRequests);

    // IMPORTANT: requests must NEVER be undefined
    await updateDoc(ref, { requests: newRequests });

    console.log("CANCEL — updateDoc completed");

    // Update UI immediately
    setAvailableShifts(prev =>
      prev.map(s =>
        s.id === shiftId ? { ...s, requests: newRequests } : s
      )
    );

    alert("Request cancelled!");

  } catch (err) {
    console.error("CANCEL REQUEST ERROR:", err);
  }
};



  





  // Fetch shifts + availability
  useEffect(() => {
    if (!user) return;
    const fetchData = async () => {
		
      setLoading(true);
      try {
		  
		  
		  // Load available shifts (status: "Open")
// Load available shifts (status: "Open")
const openQuery = query(
  collection(db, "shifts"),
  where("status", "==", "Open")
);
const openSnap = await getDocs(openQuery);

const shiftsRaw = openSnap.docs.map((d) => ({ id: d.id, ...d.data() }));

// ⭐ SORT by date ASC (earliest first)
const sorted = [...shiftsRaw].sort(
  (a, b) => new Date(a.date) - new Date(b.date)
);

setAvailableShifts(sorted);


        const staffQuery = query(
          collection(db, "staff"),
          where("email", "==", user.email.toLowerCase())
        );
        const staffSnap = await getDocs(staffQuery);
        if (staffSnap.empty) {
          setLoading(false);
          return;
		  
		  
        }

        const staffDoc = staffSnap.docs[0];
        setStaffDocId(staffDoc.id);
        const staffData = staffDoc.data();

        if (Array.isArray(staffData.daysAvailable)) {
          setDaysAvailable(staffData.daysAvailable);
        }

        const shiftQuery = query(
		  collection(db, "shifts"),
		  where("staffId", "==", staffDoc.id)
		);
		const shiftSnap = await getDocs(shiftQuery);

		if (!shiftSnap.empty) {
		  const all = shiftSnap.docs.map((d) => {
			const data = d.data();

			// Normalize the date field to yyyy-MM-dd string
			let dateStr;
			if (data.date?.toDate) {
			  // Firestore Timestamp
			  dateStr = format(data.date.toDate(), "yyyy-MM-dd");
			} else {
			  // Stored as string already
			  dateStr = data.date;
			}

			return { id: d.id, ...data, dateStr };
		  });

		



		  const upcoming = all
  .filter((s) => !isShiftCompleted(s))
  .sort((a, b) => {
    const dA = new Date(a.dateStr);
    const dB = new Date(b.dateStr);

    // Extract start times
    const [aStartHour, aStartMin] = a.startTime.split(":").map(Number);
    const [bStartHour, bStartMin] = b.startTime.split(":").map(Number);

    dA.setHours(aStartHour || 0);
    dA.setMinutes(aStartMin || 0);

    dB.setHours(bStartHour || 0);
    dB.setMinutes(bStartMin || 0);

    return dA - dB;
  });



	const past = all
	.filter((s) => isShiftCompleted(s)) // only completed
	.sort((a, b) => (a.dateStr < b.dateStr ? 1 : -1));

		  console.log("✅ Upcoming:", upcoming);
		  console.log("✅ Past:", past);

		  setAllShifts({ upcoming, past });
		} else {
		  console.log("⚠️ No shifts found for staffId:", staffDoc.id);
		}


		
		
		
		
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
	  
	  
	  
    };
    fetchData();
	
	// 🕒 Auto-refresh every minute
	const interval = setInterval(fetchData, 60 * 1000);
	return () => clearInterval(interval);

	
	
	
  }, [user]);
  
  
  
  
  
 
  
  // 🕒 Auto-refresh logic: move completed shifts to past as time passes
	useEffect(() => {
  const interval = setInterval(() => {
    setAllShifts((prev) => ({ ...prev })); // triggers re-render & re-check completion
  }, 60000); // every 1 minute
  return () => clearInterval(interval);
}, []);


  // Save updated availability
  const handleSaveAvailability = async () => {
    if (!staffDocId) return;
    setSaving(true);
    try {
      const ref = doc(db, "staff", staffDocId);
      await updateDoc(ref, { daysAvailable });
      alert("✅ Availability updated successfully!");
    } catch (err) {
      console.error(err);
      alert("❌ Failed to update availability.");
    } finally {
      setSaving(false);
    }
  };

  if (loading)
    return (
      <div className="flex items-center justify-center min-h-screen text-gray-300 bg-gray-700/80">
        Loading your shifts...
      </div>
    );

  const nextShift = allShifts.upcoming[0];
  const others = allShifts.upcoming.slice(1);
  const pastShifts = allShifts.past;

  const allDays = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

  return (
    <div
      style={{ paddingTop: "20px" }}
      className="p-6 pt-20 min-h-screen bg-gray-700/80 text-gray-100"
    >
      {/* Header */}
      <h1
        style={{
          textAlign: "center",
          color: "gray",
          backgroundColor: "white",
          boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
          width: "fit-content",
          margin: "10px auto",
          fontSize: "16px",
          fontWeight: "500",
          padding: "14px 24px",
          borderRadius: "20px",
        }}
      >
        My Shifts & Availability
      </h1>

      {/* Next Shift Card */}
	 
      <div
		  style={{
			maxWidth: "900px",
			margin: "30px auto 0 auto",
			backgroundColor: "white",
			borderRadius: "16px",
			padding: "24px",
			color: "#1f2937",
			boxShadow: "0 4px 8px rgba(0,0,0,0.05)",
		  }}
		>
		  <h2 style={{ fontSize: "16px", fontWeight: "600", marginBottom: "16px" }}>
			Your Next Shift
		  </h2>

		  {nextShift ? (
			<ShiftCard
				  shift={nextShift}
				  nextShiftId={nextShift.id}
				  onClick={() => navigate(`/staff/shifts/${nextShift.id}`)}
				/>

		  ) : (
			<p style={{ color: "gray" }}>No upcoming shifts assigned.</p>
		  )}
		</div>

	  
	  
	  
	  
	  
	  
	  

      {/* All Shifts */}
      {others.length > 0 && (
  <div
    style={{
      maxWidth: "900px",
      margin: "30px auto",
      backgroundColor: "white",
      borderRadius: "16px",
      padding: "24px",
      color: "#1f2937",
      boxShadow: "0 4px 8px rgba(0,0,0,0.05)",
    }}
  >
    <h2
      style={{
        fontSize: "16px",
        fontWeight: "600",
        marginBottom: "16px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      All Upcoming Shifts
      <span style={{ fontSize: "13px", color: "#6b7280" }}>
        Showing {Math.min(visibleUpcomingCount, others.length)} of {others.length}
      </span>
    </h2>

    <div style={{ display: "grid", gap: "16px" }}>
      {others.slice(0, visibleUpcomingCount).map((shift) => (
	  
	  <ShiftCard
		  key={shift.id}
		  shift={shift}
		  nextShiftId={nextShift?.id}
		  onClick={() => navigate(`/staff/shifts/${shift.id}`)}
		/>


      ))}
    </div>

    {visibleUpcomingCount < others.length && (
      <button
        onClick={() =>
          setVisibleUpcomingCount((prev) => prev + 5) // show 5 more each click
        }
        style={{
          marginTop: "16px",
          display: "block",
          marginLeft: "auto",
          marginRight: "auto",
          backgroundColor: "#f3f4f6",
          border: "1px solid #d1d5db",
          borderRadius: "8px",
          padding: "8px 14px",
          color: "#374151",
          fontSize: "13px",
          cursor: "pointer",
          transition: "background-color 0.2s ease",
        }}
        onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#e5e7eb")}
        onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#f3f4f6")}
      >
        Load More
      </button>
    )}
  </div>
)}




{/* ─────────────── Available Shifts (Collapsible) ─────────────── */}
<div
  style={{
    maxWidth: "900px",
    margin: "30px auto",
    backgroundColor: "white",
    borderRadius: "16px",
    padding: "24px",
    color: "#1f2937",
    boxShadow: "0 4px 8px rgba(0,0,0,0.05)",
  }}
>
  <h2
    style={{
      fontSize: "16px",
      fontWeight: "600",
      marginBottom: "16px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      cursor: "pointer",
    }}
    onClick={() => setShowAvailable((prev) => !prev)}
  >
    Available Shifts
    <span style={{ fontSize: "14px", color: "#6b7280" }}>
      {showAvailable ? "▲ Hide" : "▼ Show"}
    </span>
  </h2>

  {showAvailable && (
    <div style={{ display: "grid", gap: "16px" }}>
      {availableShifts.length === 0 ? (
        <p style={{ fontSize: "13px", color: "#6b7280" }}>
          No available shifts right now.
        </p>
      ) : (
        availableShifts.map((shift) => (
          <div
            key={shift.id}
            style={{
              border: "1px solid #e5e7eb",
              borderRadius: "16px",
              padding: "16px",
              backgroundColor: "#f9fafb",
            }}
          >
            <h3 style={{ fontSize: "15px", fontWeight: "600" }}>
              {shift.clientName}
            </h3>
           
{/* Show requested label if THIS user already requested */}
{/* Show requested label IF this user already requested */}
{Array.isArray(shift.requests) &&
 shift.requests.some(r => r.email === user.email) && (
  <p
    style={{
      fontSize: "12px",
      marginTop: "4px",
      color: "purple",
      fontWeight: "600",
    }}
  >
    Interested (You requested this shift)
  </p>
)}




			
			
			<div style={{ color: "#444", fontSize: "13px", marginTop: "4px" }}>
  📍 {shift.clientPostcode || shift.clientAddress || "No address"}
</div>


		{/* NEW — Shift Date & Time */}
<div style={{ color: "#444", fontSize: "13px", marginTop: "4px" }}>
  📅 {shift.date
    ? format(new Date(shift.date), "EEE, dd MMM yyyy")
    : "No date"}
</div>


<div style={{ color: "#444", fontSize: "13px", marginTop: "2px" }}>
  ⏰ {shift.startTime && shift.endTime
    ? `${shift.startTime} - ${shift.endTime}`
    : "No time"}
</div>



            <p style={{ fontSize: "12px", color: "#9ca3af", marginTop: "2px" }}>
              Rate: £13/hr
            </p>

            
          {/* Button – Request or Cancel */}
{Array.isArray(shift.requests) &&
 shift.requests.some(r => r.email === user.email) ? (
  // 🔴 Already Requested → Show Cancel Button
  <button
    onClick={() => cancelShiftRequest(shift.id)}
    style={{
      marginTop: "12px",
      width: "100%",
      padding: "12px",
      borderRadius: "10px",
      backgroundColor: "#dc3545",   // red
      color: "#fff",
      fontWeight: "600",
      border: "none",
    }}
  >
    Cancel Request
  </button>
) : (
  // 🔵 Not Requested → Show Request Button
  <button
    onClick={() => requestShift(shift.id)}
    style={{
      marginTop: "12px",
      width: "100%",
      padding: "12px",
      borderRadius: "10px",
      backgroundColor: "#007bff",   // blue
      color: "#fff",
      fontWeight: "600",
      border: "none",
    }}
  >
    Request Shift
  </button>
)}







          </div>
        ))
      )}
    </div>
  )}
</div>







      {/* Availability Section */}
      <div
        style={{
          maxWidth: "900px",
          margin: "30px auto",
          backgroundColor: "white",
          borderRadius: "16px",
          padding: "24px",
          color: "#1f2937",
          boxShadow: "0 4px 8px rgba(0,0,0,0.05)",
        }}
      >
        <h2 style={{ fontSize: "16px", fontWeight: "600", marginBottom: "16px" }}>
          My Availability
        </h2>

        <p style={{ color: "#6b7280", fontSize: "14px", marginBottom: "12px" }}>
          Select the days you’re available to work:
        </p>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(100px, 1fr))",
            gap: "10px",
            marginBottom: "20px",
          }}
        >
          {allDays.map((day) => {
            const selected = daysAvailable.includes(day);
            return (
              <button
                key={day}
                onClick={() => {
                  if (selected)
                    setDaysAvailable(daysAvailable.filter((d) => d !== day));
                  else setDaysAvailable([...daysAvailable, day]);
                }}
                style={{
                  padding: "10px 14px",
                  borderRadius: "10px",
                  border: selected ? "2px solid #10b981" : "1px solid #d1d5db",
                  backgroundColor: selected ? "#dcfce7" : "#f9fafb",
                  color: selected ? "#065f46" : "#374151",
                  fontWeight: "500",
                  cursor: "pointer",
                  transition: "all 0.2s ease",
                }}
              >
                {day}
              </button>
            );
          })}
        </div>

        <button
          onClick={handleSaveAvailability}
          disabled={saving}
          style={{
            backgroundColor: saving ? "#9ca3af" : "#10b981",
            color: "white",
            padding: "10px 18px",
            borderRadius: "10px",
            fontWeight: "500",
            cursor: saving ? "not-allowed" : "pointer",
          }}
        >
          {saving ? "Saving..." : "💾 Save Availability"}
        </button>
      </div>
	  
	  
	  	  
			  {/* Past Shifts Section */}
		{pastShifts.length > 0 && (
		  <div
			style={{
			  maxWidth: "900px",
			  margin: "30px auto",
			  backgroundColor: "white",
			  borderRadius: "16px",
			  padding: "24px",
			  color: "#1f2937",
			  boxShadow: "0 4px 8px rgba(0,0,0,0.05)",
			}}
		  >
			<h2 style={{ 
			fontSize: "16px", 
			fontWeight: "600", 
			marginBottom: "16px", 
			display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            cursor: "pointer", 
			}}
			onClick={() => setShowPast(!showPast)}
			
			>
			  Past Shifts
			  <span style={{ fontSize: "14px", color: "#6b7280" }}>
        {showPast ? "▲ Hide" : "▼ Show"}
      </span>
			  
			</h2>
			
			{showPast && (
			<div style={{ display: "grid", gap: "16px" }}>
			
			  {pastShifts.map((shift) => (
  <Link to={`/staff/shifts/${shift.id}`} key={shift.id}>
    <ShiftCard shift={shift} />
  </Link>
))}

			</div>
			)}
		  </div>
		)}
	  
    </div>
  );
}



/* ─────────────── ShiftCard ─────────────── */
function ShiftCard({ shift, onClick, nextShiftId }) {
  const hasMap = shift.clockInLocation || shift.clockOutLocation;
  const clockIn = shift.clockInLocation;
  const clockOut = shift.clockOutLocation;
  const polyline =
    clockIn && clockOut
      ? [
          [clockIn.lat, clockIn.lng],
          [clockOut.lat, clockOut.lng],
        ]
      : null;
	  
	    // 🕒 Determine if shift has ended
  const now = new Date();
  const shiftEndTime = new Date(shift.date);
  if (shift.endTime) {
    const [endHour, endMin] = shift.endTime.split(":").map(Number);
    shiftEndTime.setHours(endHour);
    shiftEndTime.setMinutes(endMin);
  }

  const shiftCompleted = now > shiftEndTime;
  
  
  
  // Allow check-in only within 30 minutes before start time until shift end
let canCheckIn = false;
if (shift.startTime && shift.endTime) {
  const [startStr] = shift.startTime.split("–");
  const [endStr] = shift.endTime.split("–");
  const [startHour, startMin] = startStr.split(":").map(Number);
  const [endHour, endMin] = endStr.split(":").map(Number);
  const shiftStart = new Date(shift.date);
  shiftStart.setHours(startHour);
  shiftStart.setMinutes(startMin);
  const shiftEnd = new Date(shift.date);
  shiftEnd.setHours(endHour);
  shiftEnd.setMinutes(endMin);

  const checkWindowStart = new Date(shiftStart.getTime() - 60 * 60 * 1000); // 30 min before
  const nowTime = new Date();
  canCheckIn = nowTime >= checkWindowStart && nowTime <= shiftEnd;
}

  
  
  
  

  const [loading, setLoading] = useState(false);
const [message, setMessage] = useState("");
const [showPast, setShowPast] = useState(false);



const distanceBetween = (lat1, lon1, lat2, lon2) => {
  const R = 6371e3; // metres
  const φ1 = (lat1 * Math.PI) / 180;
  const φ2 = (lat2 * Math.PI) / 180;
  const Δφ = ((lat2 - lat1) * Math.PI) / 180;
  const Δλ = ((lon2 - lon1) * Math.PI) / 180;
  const a =
    Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
    Math.cos(φ1) *
      Math.cos(φ2) *
      Math.sin(Δλ / 2) *
      Math.sin(Δλ / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c; // distance in metres
};


 /* ⭐⭐⭐ ADD THIS LINE HERE ⭐⭐⭐ */
  //const isNextShift = shift.id === nextShiftId;
  const isNextShift = shift.id === nextShiftId;
const isCheckedInShift = shift.status === "Checked In";  

  /* ⭐⭐⭐ END OF ADDED LINE ⭐⭐⭐ */

  // distanceBetween...
  // handleCheck function continues below


const handleCheck = async (type) => {
	
	// ⛔ Prevent multiple check-ins on the same shift
if (type === "in" && shift.checkInTime) {
  setMessage("You have already checked in for this shift. Only the first check-in is recorded.");
  return;
}

  if (!shift.clientLocation) {
    setMessage("No client location found for this shift.");
    return;
  }

  setLoading(true);
  navigator.geolocation.getCurrentPosition(
    async (pos) => {
      const { latitude, longitude } = pos.coords;
      const dist = distanceBetween(
        latitude,
        longitude,
        shift.clientLocation.lat,
        shift.clientLocation.lng
      );

      if (dist > 1000) {
        setMessage("You are too far from the client location to check in/out.");
        setLoading(false);
        return;
      }

      const shiftRef = doc(db, "shifts", shift.id);
      const updateData =
        type === "in"
          ? {
              checkInTime: serverTimestamp(),
              checkInLocation: { lat: latitude, lng: longitude },
              status: "Checked In",
            }
          : {
              checkOutTime: serverTimestamp(),
              checkOutLocation: { lat: latitude, lng: longitude },
              status: "Checked Out",
            };

      await updateDoc(shiftRef, updateData);
      setMessage(`✅ ${type === "in" ? "Checked in" : "Checked out"} successfully!`);
      setLoading(false);
    },
    (err) => {
      console.error(err);
      setMessage("Unable to access your location. Please enable GPS.");
      setLoading(false);
    }
  );
};

  return (
    <div
	  onClick={onClick}
      style={{
        border: "1px solid #e5e7eb",
        borderRadius: "16px",
        padding: "20px",
        backgroundColor: "#f9fafb",
        boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
		cursor: "pointer", 
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          marginBottom: "8px",
        }}
      >
        <div>
          <h3 style={{ fontSize: "16px", fontWeight: "600" }}>{shift.clientName}</h3>
          <p style={{ fontSize: "13px", color: "#6b7280" }}>
            {format(new Date(shift.date), "EEE, dd MMM yyyy")} •{" "}
            {shift.startTime} - {shift.endTime}
          </p>
          {shift.location && (
            <p style={{ fontSize: "12px", color: "#9ca3af", marginTop: "2px" }}>
              📍 {shift.location}
            </p>
          )}
        </div>
		



        <span
          style={{
            padding: "6px 12px",
            borderRadius: "9999px",
			textAlign: "center",
            fontSize: "10px",
            fontWeight: "600",
            backgroundColor:
              shift.status === "Checked In"
                ? "#dcfce7"
                : shift.status === "Assigned"
                ? "#fef9c3"
                : "#e5e7eb",
            color:
              shift.status === "Checked In"
                ? "#15803d"
                : shift.status === "Assigned"
                ? "#a16207"
                : "#374151",
          }}
        >
          {shift.status || "Pending"}
        </span>
      </div>

      <div
        style={{
          color: "#4b5563",
          fontSize: "13px",
          marginBottom: "10px",
          lineHeight: "1.5",
        }}
      >
        {shift.notes && <p>📝 {shift.notes}</p>}
        {shift.rate && <p>💷 Rate: £{shift.rate}/hr</p>}
        {shift.totalHours && <p>⏱️ Total Hours: {shift.totalHours}</p>}
      </div>


{/* New: Get Directions */}
<div style={{ marginTop: "4px" }}>


{shift.clientLocation?.lat && shift.clientLocation?.lng ? (
  <a
    onClick={(e) => e.stopPropagation()}
    href={`https://www.google.com/maps/dir/?api=1&destination=${shift.clientLocation.lat},${shift.clientLocation.lng}`}
    target="_blank"
    rel="noopener noreferrer"
    style={{
      display: "inline-block",
      color: "#0284c7",
      fontWeight: "500",
      fontSize: "13px",
      marginTop: "4px",
      textDecoration: "underline",
    }}
  >
    Get Directions
  </a>
) : (
  <span style={{ color: "red", fontSize: "13px" }}>
    Location unavailable
  </span>
)}









</div>



		{/* New: First Check-in Time */}
{shift.checkInTime && (() => {
  let d = shift.checkInTime;

  // If it's a Firestore Timestamp, convert it
  if (d && typeof d.toDate === "function") {
    d = d.toDate();
  } else {
    // If it's a string / number, make a Date from it
    d = new Date(d);
  }

  // If still not a valid date, show nothing
  if (isNaN(d.getTime())) return null;

  const timeStr = d.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
  });

  const dateStr = d.toLocaleDateString([], {
    weekday: "short",
    day: "2-digit",
    month: "short",
  });

  return (
    <div
      style={{
        fontSize: "11px",
        marginTop: "10px",
        color: "#0369a1",
        textAlign: "left",
		fontWeight: "300",
      }}
    >
      Checked in at: {timeStr} ({dateStr})
    </div>
  );
})()}


{/* New: Check-out Time */}
{shift.checkOutTime && (() => {
  let t = shift.checkOutTime;

  // Convert Firestore Timestamp → JS Date
  if (t && typeof t.toDate === "function") {
    t = t.toDate();
  } else {
    t = new Date(t);
  }

  if (isNaN(t.getTime())) return null;

  const timeStr = t.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
  const dateStr = t.toLocaleDateString([], { weekday: "short", day: "2-digit", month: "short" });

  return (
    <div
      style={{
        fontSize: "11px",
        marginTop: "2px",
        color: "#dc2626", // 🔴 Tailwind Red-600 equivalent
        textAlign: "left",
        fontWeight: "300",
      }}
    >
      Checked out at: {timeStr} ({dateStr})
    </div>
  );
})()}



           {/* Actions (Call + Check buttons) */}
     

<div
  style={{
    display: "grid",
    gap: "8px",
    marginTop: "12px",
  }}
>
  <a
    onClick={(e) => e.stopPropagation()}
    href="tel:+447599121308"
    style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "6px",
      border: "1px solid #0284c7",
      color: "#0369a1",
      padding: "10px 0",
      borderRadius: "10px",
      fontWeight: "500",
      fontSize: "13px",
      textDecoration: "none",
    }}
  >
    <Phone size={14} /> Call Office
  </a>

  {shiftCompleted ? (
    <span
      style={{
        backgroundColor: "#dcfce7",
        color: "#15803d",
        textAlign: "center",
        padding: "10px 0",
        borderRadius: "10px",
        fontWeight: "600",
        fontSize: "13px",
      }}
    >
      ✅ Completed
    </span>
  ) : (
    <>
      <button
  onClick={(e) => {
    e.stopPropagation();
    if (!isNextShift) {
      alert("⛔ You can only check in to your NEXT scheduled shift.");
      return;
    }
    handleCheck("in");
  }}
  disabled={loading || !canCheckIn || !isNextShift}
  style={{
    backgroundColor: isNextShift ? (canCheckIn ? "#16a34a" : "#9ca3af") : "#cbd5e1",
    color: "white",
    padding: "10px 0",
    borderRadius: "10px",
    fontSize: "13px",
    border: "none",
    cursor: isNextShift && canCheckIn ? "pointer" : "not-allowed",
  }}
>
  Check In
</button>



      <button
  onClick={(e) => {
    e.stopPropagation();

    // Must be the active checked-in shift
    if (!isCheckedInShift) {
      alert("⛔ You can only check out from the shift you are checked into.");
      return;
    }

    handleCheck("out");
  }}
  disabled={loading || !isCheckedInShift}
  style={{
    backgroundColor: isCheckedInShift ? "#2563eb" : "#cbd5e1",
    color: "white",
    padding: "10px 0",
    borderRadius: "10px",
    fontSize: "13px",
    border: "none",
    cursor: isCheckedInShift ? "pointer" : "not-allowed",
  }}
>
  Check Out
</button>

    </>
  )}
</div>

{message && (
  <p style={{ marginTop: "8px", fontSize: "13px", color: "#4b5563" }}>
    {message}
  </p>
)}





      {hasMap && (
        <div
          style={{
            height: "250px",
            width: "100%",
            marginTop: "16px",
            borderRadius: "12px",
            overflow: "hidden",
          }}
        >
          <MapContainer
            center={[
              clockIn?.lat || clockOut?.lat || 51.505,
              clockIn?.lng || clockOut?.lng || -0.09,
            ]}
            zoom={13}
            style={{ height: "100%", width: "100%" }}
          >
            <TileLayer
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            {clockIn && (
              <Marker position={[clockIn.lat, clockIn.lng]} icon={inIcon}>
                <Popup>Clock In 📍</Popup>
              </Marker>
            )}
            {clockOut && (
              <Marker position={[clockOut.lat, clockOut.lng]} icon={outIcon}>
                <Popup>Clock Out 📍</Popup>
              </Marker>
            )}
            {polyline && <Polyline positions={polyline} color="blue" />}
          </MapContainer>
        </div>
      )}
	  
	  
	  
		

    </div>
  );
}
